module.exports = require("core-js/modules/es.symbol.is-concat-spreadable");